import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { logStore } from "@/hooks";
import { TextButton } from "@/components/common/button";
import Modal from "./Modal.vue";


/**
 * Displays a modal for confirming sensitive actions.
 */
const __default__ = {
  name: "AppConfirmModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const message = computed(() => logStore.confirmation);

const isOpen = computed(() => message.value.type !== "clear");

/**
 * Confirms the confirmation message.
 */
function handleConfirm(): void {
  message.value.statusCallback(true);
  logStore.clearConfirmation();
}

/**
 * Closes the confirmation message.
 */
function handleClose(): void {
  message.value.statusCallback(false);
  logStore.clearConfirmation();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    size: "sm",
    open: isOpen.value,
    title: message.value.title,
    subtitle: message.value.body,
    onClose: handleClose
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        label: "Confirm",
        color: "primary",
        "data-cy": "button-confirm-modal",
        onClick: handleConfirm
      })
    ]),
    _: 1
  }, 8, ["open", "title", "subtitle"]))
}
}

})